<div class="welcome-screen">
  <header class="welcome-screen__header">
    <svg class="welcome-screen__logo">
      <use spriteVersion iconName="colorjob-logo"></use>
    </svg>

    <button class="welcome-screen__logout" type="button" (click)="onLogout()">
      <svg class="welcome-screen__logout-icon">
        <use spriteVersion iconName="logout"></use>
      </svg>
      Logout
    </button>
  </header>

  <div class="welcome-screen__content" [ngClass]="contentClassName">
    @if (loading) {

      <h1 class="welcome-screen__title">Welcome back, {{ userName }}</h1>
      <p class="welcome-screen__subtitle">Select a company to continue</p>

      <div class="welcome-screen__companies-state">
        <div class="welcome-screen__table-wrapper welcome-screen__table-wrapper--loading">
          <div class="welcome-screen__table">
            <div class="welcome-screen__table-head">
              <span>Company</span>
              <span>Projects</span>
              <span>System Role</span>
              <span></span>
            </div>
            <div class="welcome-screen__loading-state" aria-hidden="true">
              <svg class="loader-spin welcome-screen__loader-spinner" width="40" height="40">
                <use spriteVersion iconName="loader-icon"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
    
} @else {

      @if (hasCompanies) {

        <div class="welcome-screen__companies-state">
        <h1 class="welcome-screen__title">Welcome back, {{ userName }}</h1>
        <p class="welcome-screen__subtitle">Select a company to continue</p>

        <div class="welcome-screen__table-wrapper" [class.welcome-screen__table-wrapper--scrollable]="isScrollableTable">
          <div class="welcome-screen__table">
            <div class="welcome-screen__table-head">
              <span>Company</span>
              <span>Projects</span>
              <span>System Role</span>
              <span></span>
            </div>

            @for (company of companies; track trackByCompanyId($index, company)) {
<div class="welcome-screen__table-row">
              <div class="welcome-screen__company-name" [title]="company.name">
                {{ company.name }}
              </div>
              <div class="welcome-screen__projects">
                {{ getProjectsLabel(company.projectsCount) }}
              </div>
              <div class="welcome-screen__role-cell">
                <span class="welcome-screen__role" [ngClass]="getRoleClass(company)">
                  {{ getRoleLabel(company) }}
                </span>
              </div>
              <div class="welcome-screen__action">
                <button
                  class="welcome-screen__select-btn"
                  type="button"
                  [disabled]="isSelecting"
                  [attr.data-loading]="selectedCompanyId === company.id"
                  (click)="onSelectCompany(company)">
                  Select
                </button>
              </div>
            </div>
}
          </div>
        </div>

        <div class="checkbox-container welcome-screen__checkbox-container">
          <label class="checkbox-label welcome-screen__checkbox-label">
            <input
              type="checkbox"
              class="visually-hidden"
              [checked]="shouldRememberSelection"
              (change)="shouldRememberSelection = !shouldRememberSelection">
            <span class="checkbox"></span>
            <span class="checkbox-text">Don't show this screen again - open my last company on sign in</span>
          </label>
        </div>

        @if (isSelecting) {
<div class="welcome-screen__loader-overlay" aria-hidden="true">
          <svg class="loader-spin welcome-screen__loader-spinner" width="40" height="40">
            <use spriteVersion iconName="loader-icon"></use>
          </svg>
        </div>
}
        </div>
      
} @else {

        <div class="welcome-screen__empty">
          <svg class="welcome-screen__empty-illustration" aria-hidden="true">
            <use spriteVersion iconName="welcome-no-access-companies"></use>
          </svg>
          <div class="welcome-screen__empty-copy">
            <h1 class="welcome-screen__empty-title">You don't have access to any companies</h1>
            <p class="welcome-screen__empty-text">You are not a member of any company yet. Contact your administrator</p>
          </div>
        </div>
      
}

      
    
}

    
  </div>
</div>
